// Event title mapping for A/B test
// A: Long title (original), B: Short title (from CSV)
export const EVENT_TITLE_MAPPING = {
  3100143: {
    a: 'MAX80名の大規模恋活【月に1度の特別企画！】おひとり参加・初参加も多数！【ビュッフェ×お酒飲み放題】昨年オープンのK-POPバー貸切♡～LOVE FES SAPPORO～',
    b: 'MAX80名の大規模恋活♡おひとり参加・初参加も多数！K-POPバー貸切'
  },
  3098551: {
    a: '早くも10名突破！MAX80名の大規模恋活♡【着席＋席替えでおひとり様も安心】～LOVE FES FUKUOKA～',
    b: '早くも10名突破！MAX80名の大規模恋活♡【着席＋席替え】おひとり様参加も多数'
  },
  3099116: {
    a: '早くも20名突破！前回120名参加♡月1の特別大規模恋活♡【おひとり様も多数♪】【着席席替え×フリータイム】【スイーツ付ビュッフェ×フリードリンク】～LOVE FES TOKYO～',
    b: '早くも20名突破！前回120名参加♡月1の特別大規模恋活♡おひとり様も多数！'
  },
  3098537: {
    a: '開催確定♡MAX80名大規模恋活♡おひとり様参加も多数！【ビュッフェ×種類豊富なフリードリンク♪】【大人の広々ダイニングバー貸切】～LOVE FES TOKYO～',
    b: '開催確定！MAX80名大規模恋活♡着席＋席替えでおひとり様も安心！'
  },
  3099099: {
    a: '開催確定♡前回70名人気企画♡月1の特別な大規模恋活【ビュッフェ×飲み放題付♪】【着席＋席替えでおひとり様も安心】【洗練された贅沢なダイニングで開催】～LOVE FES TOKYO～',
    b: '開催確定♡前回70名人気企画♡月1の特別大規模恋活♡着席席替えでおひとり様も安心'
  },
  3098536: {
    a: '大規模恋活♡【着席＋席替えでおひとり様も安心♡】【種類豊富なフリードリンク×ビュッフェ付♪】【大人の広々ダイニングバー貸切】～LOVE FES TOKYO～',
    b: '大規模恋活♡着席＋席替えでおひとり様も安心♡フリードリンク×ビュッフェ付♪'
  },
  3098953: {
    a: '【銀座水響亭】MOST最高級オシャレ会場で2対2の着席席替え！【お酒飲み放題】【一人参加も歓迎】【MOST】',
    b: '最高級会場 2対2着席席替え 飲み放題'
  },
  3098954: {
    a: '【銀座水響亭】MOST最高級オシャレ会場で2対2の着席席替え！【お酒飲み放題】【一人参加も歓迎】【MOST】',
    b: '最高級会場 2対2着席席替え 飲み放題'
  },
  3098955: {
    a: '【銀座水響亭】MOST最高級オシャレ会場で2対2の着席席替え！【お酒飲み放題】【一人参加も歓迎】【MOST】',
    b: '最高級会場 2対2着席席替え 飲み放題'
  },
  3098956: {
    a: '【銀座水響亭】MOST最高級オシャレ会場で2対2の着席席替え！【お酒飲み放題】【一人参加も歓迎】【MOST】',
    b: '最高級会場 2対2着席席替え 飲み放題'
  },
  3098255: {
    a: '【着席】【2on2形式】【スパークリング×50種ドリンク飲み放題】【おひとり様も歓迎】【MOST最高級レストラン】【MOST】',
    b: '着席2on2 スパークリング等飲み放題'
  },
  3098256: {
    a: '【着席】【2on2形式】【スパークリング×50種ドリンク飲み放題】【おひとり様も歓迎】【MOST最高級レストラン】【MOST】',
    b: '着席2on2 スパークリング等飲み放題'
  },
  3098257: {
    a: '【着席】【2on2形式】【スパークリング×50種ドリンク飲み放題】【おひとり様も歓迎】【MOST最高級レストラン】【MOST】',
    b: '着席2on2 スパークリング等飲み放題'
  },
  3098258: {
    a: '【着席】【2on2形式】【スパークリング×50種ドリンク飲み放題】【おひとり様も歓迎】【MOST最高級レストラン】【MOST】',
    b: '着席2on2 スパークリング等飲み放題'
  },
  3098259: {
    a: '【着席】【2on2形式】【スパークリング×50種ドリンク飲み放題】【おひとり様も歓迎】【MOST最高級レストラン】【MOST】',
    b: '着席2on2 スパークリング等飲み放題'
  },
  3101134: {
    a: '【着席】【高級店で最大120名】月に一度の特別企画【お酒×プチデザート】【MOST】',
    b: '着席 最大120名 月に一度の特別企画'
  },
  3097666: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3097667: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3097672: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3097669: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3097673: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3097670: {
    a: '【着席】MOST最安値【おひとり様歓迎】【完全着席×スタッフが席替え】【ドリンクつき】【1人参加歓迎】',
    b: 'MOST最安値！おひとり様歓迎【着席】'
  },
  3098886: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098891: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098887: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098892: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098888: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098889: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098893: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098890: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098894: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098504: {
    a: '【着席】デザート付き【2on2】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 お酒飲み放題 1人参加歓迎'
  },
  3098965: {
    a: '【着席】ミスド食べ放題【アニメ好き限定】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 アニメ好き限定 ミスド食べ飲み放題'
  },
  3098968: {
    a: '【着席】ミスド食べ放題【アニメ好き限定】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 アニメ好き限定 ミスド食べ飲み放題'
  },
  3098969: {
    a: '【着席】ミスド食べ放題【アニメ好き限定】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 アニメ好き限定 ミスド食べ飲み放題'
  },
  3098970: {
    a: '【着席】ミスド食べ放題【アニメ好き限定】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 アニメ好き限定 ミスド食べ飲み放題'
  },
  3097640: {
    a: '【着席】ミスド食べ放題【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 ミスド食べ飲み放題 1人参加歓迎'
  },
  3097642: {
    a: '【着席】ミスド食べ放題【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 ミスド食べ飲み放題 1人参加歓迎'
  },
  3097644: {
    a: '【着席】ミスド食べ放題【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 ミスド食べ飲み放題 1人参加歓迎'
  },
  3097645: {
    a: '【着席】ミスド食べ放題【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 ミスド食べ飲み放題 1人参加歓迎'
  },
  3101088: {
    a: '【着席】月1回の特別企画【2on2】【ビュッフェ料理×お酒飲み放題】【ボールペン無料】【シックスセンス･リゾート】【1人参加歓迎】【MOST】',
    b: '着席2on2 特別企画 1人参加歓迎'
  },
  3098957: {
    a: '【着席】高級店を貸切【2on2形式】【スパークリング×50種ドリンク飲み放題】【MOST最高級レストラン】【MOST】',
    b: '着席2on2形式 高級店貸切 飲み放題'
  },
  3098877: {
    a: '【着席】食べ放題【100分企画】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 食べ飲み放題 1人参加歓迎'
  },
  3098878: {
    a: '【着席】食べ放題【100分企画】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 食べ飲み放題 1人参加歓迎'
  },
  3098879: {
    a: '【着席】食べ放題【100分企画】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 食べ飲み放題 1人参加歓迎'
  },
  3098880: {
    a: '【着席】食べ放題【100分企画】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 食べ飲み放題 1人参加歓迎'
  },
  3098881: {
    a: '【着席】食べ放題【100分企画】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 食べ飲み放題 1人参加歓迎'
  },
  3104018: {
    a: '【着席】食べ放題つき【リンツ＆ゴディバ＆お酒飲み放題】【MOST】',
    b: '着席 リンツ＆ゴディバ食べ飲み放題'
  },
  3104015: {
    a: '【着席】食べ放題つき【リンツ＆ゴディバ＆お酒飲み放題】【MOST】',
    b: '着席 リンツ＆ゴディバ食べ飲み放題'
  },
  3104016: {
    a: '【着席】食べ放題つき【リンツ＆ゴディバ＆お酒飲み放題】【MOST】',
    b: '着席 リンツ＆ゴディバ食べ飲み放題'
  },
  3104014: {
    a: '【着席】食べ放題つき【リンツ＆ゴディバ＆お酒飲み放題】【MOST】',
    b: '着席 リンツ＆ゴディバ食べ飲み放題'
  },
  3104017: {
    a: '【着席】食べ放題つき【リンツ＆ゴディバ＆お酒飲み放題】【MOST】',
    b: '着席 リンツ＆ゴディバ食べ飲み放題'
  },
  3098882: {
    a: '【着席】食べ放題つき【上野公園内】【お酒飲み放題×パン＆スイーツ食べ放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 パン等食べ飲み放題 1人参加歓迎'
  },
  3098883: {
    a: '【着席】食べ放題つき【上野公園内】【お酒飲み放題×パン＆スイーツ食べ放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 パン等食べ飲み放題 1人参加歓迎'
  },
  3098884: {
    a: '【着席】食べ放題つき【上野公園内】【お酒飲み放題×パン＆スイーツ食べ放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 パン等食べ飲み放題 1人参加歓迎'
  },
  3098885: {
    a: '【着席】食べ放題つき【上野公園内】【お酒飲み放題×パン＆スイーツ食べ放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 パン等食べ飲み放題 1人参加歓迎'
  },
  3099909: {
    a: '【着席2on2】120名の大型会場【美味しいお酒飲み放題】【無料手荷物】【フリータイム無し】【キツネ】【MOST】',
    b: '着席2on2 120名会場 お酒飲み放題'
  },
  3099911: {
    a: '【着席2on2】120名の大型会場【美味しいお酒飲み放題】【無料手荷物】【フリータイム無し】【キツネ】【MOST】',
    b: '着席2on2 120名会場 お酒飲み放題'
  },
  3101139: {
    a: '【着席2on2】MOST最安値【駅近の貸切会場】【スタッフが席替え】【ドリンクつき】',
    b: '着席2on2 MOST最安値 駅近貸切'
  },
  3099855: {
    a: '【着席2on2】お得な120分企画【プレミアムモルツ・スパーリング飲み放題】【2on2】【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102719: {
    a: '【着席2on2】ジヴェ品川 -givet-【お得な120分】【プレミアムモルツ・スパーリング飲み放題】【2on2】【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102721: {
    a: '【着席2on2】ジヴェ品川 -givet-【お得な120分】【プレミアムモルツ・スパーリング飲み放題】【2on2】【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102716: {
    a: '【着席2on2】ジヴェ品川 -givet-【お得な120分】【プレミアムモルツ・スパーリング飲み放題】【2on2】【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102717: {
    a: '【着席2on2】ジヴェ品川 -givet-【お得な120分】【プレミアムモルツ・スパーリング飲み放題】【2on2】【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102724: {
    a: '【着席2on2】プレミアムモルツ・スパーリング飲み放題【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102730: {
    a: '【着席2on2】プレミアムモルツ・スパーリング飲み放題【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102726: {
    a: '【着席2on2】プレミアムモルツ・スパーリング飲み放題【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3102731: {
    a: '【着席2on2】プレミアムモルツ・スパーリング飲み放題【高級レストラン】【おひとり様も多数ご参加】【MOST】',
    b: '着席2on2 スパーリング等飲み放題'
  },
  3099839: {
    a: '【着席2on2】一等地の高級店【ランチ×30種お酒】【MOST最高級レストラン】【マイモン銀座店】【MOST】',
    b: '着席2on2 MOST最高級ランチ×お酒'
  },
  3099840: {
    a: '【着席2on2】一等地の高級店【ランチ×30種お酒】【MOST最高級レストラン】【マイモン銀座店】【MOST】',
    b: '着席2on2 MOST最高級ランチ×お酒'
  },
  3099841: {
    a: '【着席2on2】一等地の高級店【ランチ×30種お酒】【MOST最高級レストラン】【マイモン銀座店】【MOST】',
    b: '着席2on2 MOST最高級ランチ×お酒'
  },
  3099842: {
    a: '【着席2on2】一等地の高級店【ランチ×30種お酒】【MOST最高級レストラン】【マイモン銀座店】【MOST】',
    b: '着席2on2 MOST最高級ランチ×お酒'
  },
  3102467: {
    a: '【着席2on2】金曜のお仕事終わりに【ディナー×お酒飲み放題】【MOST】',
    b: '着席2on2 お仕事終わりディナー×お酒'
  },
  3102465: {
    a: '【着席2on2】金曜のお仕事終わりに【ディナー×お酒飲み放題】【MOST】',
    b: '着席2on2 お仕事終わりディナー×お酒'
  },
  3102468: {
    a: '【着席2on2】金曜のお仕事終わりに【ディナー×お酒飲み放題】【MOST】',
    b: '着席2on2 お仕事終わりディナー×お酒'
  },
  3100327: {
    a: '【着席2on2】月に一度の特別企画【料理×お酒×スイーツ×ダーツ】【MOST】',
    b: '着席2on2 特別企画 スイーツ×ダーツ'
  },
  3103407: {
    a: '【着席2on2】高評価レストラン【料理つき×お酒飲み放題】【ロクカフェ横浜店】【MOST】',
    b: '着席2on2 高評価レストラン 料理お酒'
  },
  3099914: {
    a: '【着席2on2】最大100名の大型会場【ディナーつき×お酒飲み放題】【無料手荷物】【フリータイム無し】【キツネ】【MOST】',
    b: '着席2on2 ディナー×お酒飲み放題'
  },
  3099915: {
    a: '【着席2on2】最大100名の大型会場【ディナーつき×お酒飲み放題】【無料手荷物】【フリータイム無し】【キツネ】【MOST】',
    b: '着席2on2 ディナー×お酒飲み放題'
  },
  3099851: {
    a: '【着席2on2】取り放題ビュッフェ【クラフトビール】【無料手荷物】【ゴッチバッタ銀座】【MOST】',
    b: '着席2on2 ビュッフェ×クラフトビール'
  },
  3099852: {
    a: '【着席2on2】取り放題ビュッフェ【クラフトビール】【無料手荷物】【ゴッチバッタ銀座】【MOST】',
    b: '着席2on2 ビュッフェ×クラフトビール'
  },
  3099853: {
    a: '【着席2on2】取り放題ビュッフェ【クラフトビール】【無料手荷物】【ゴッチバッタ銀座】【MOST】',
    b: '着席2on2 ビュッフェ×クラフトビール'
  },
  3099854: {
    a: '【着席2on2】取り放題ビュッフェ【クラフトビール】【無料手荷物】【ゴッチバッタ銀座】【MOST】',
    b: '着席2on2 ビュッフェ×クラフトビール'
  },
  3099161: {
    a: '【着席2on2】食べ放題つき【リンツ＆ゴディバ】【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 食べ飲み放題 1人参加歓迎'
  },
  3099162: {
    a: '【着席2on2】食べ放題つき【リンツ＆ゴディバ】【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 食べ飲み放題 1人参加歓迎'
  },
  3099163: {
    a: '【着席2on2】食べ放題つき【リンツ＆ゴディバ】【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 食べ飲み放題 1人参加歓迎'
  },
  3099164: {
    a: '【着席2on2】食べ放題つき【リンツ＆ゴディバ】【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 食べ飲み放題 1人参加歓迎'
  },
  3099165: {
    a: '【着席2on2】食べ放題つき【リンツ＆ゴディバ】【上野公園内】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席2on2 食べ飲み放題 1人参加歓迎'
  },
  3107708: {
    a: '【着席型】コレド室町の高級和食店【懐石料理×お酒飲み放題】【MOST】',
    b: '着席型 高級和食 懐石料理×お酒'
  },
  3097628: {
    a: '【着席形式】ミスド食べ放題【アニメ好き限定】【お酒飲み放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '着席 ミスド食べ飲み放題 アニメ好き限定'
  },
  3099126: {
    a: '【特別企画】お友達と同席【ビュッフェ料理×お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'お友達と同席 ビュッフェ×お酒飲み放題'
  },
  3098958: {
    a: 'おひとり様歓迎【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '2on2 着席席替え 高級店 飲み放題'
  },
  3098959: {
    a: 'おひとり様歓迎【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '2on2 着席席替え 高級店 飲み放題'
  },
  3098960: {
    a: 'おひとり様歓迎【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '2on2 着席席替え 高級店 飲み放題'
  },
  3098961: {
    a: 'おひとり様歓迎【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '2on2 着席席替え 高級店 飲み放題'
  },
  3088890: {
    a: 'おひとり様歓迎【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '2on2 着席席替え 高級店 飲み放題'
  },
  3086814: {
    a: 'おひとり様歓迎【2on2形式】【一等地の高級店】【軽食×30種お酒】【MOST最高級レストラン】【マイモン銀座店】【MOST】',
    b: '2on2 着席席替え 軽食×飲み放題'
  },
  3098033: {
    a: 'おひとり様歓迎【2on2形式】【完全着席×スタッフが席替え】【ドリンク付き】【MOST】',
    b: '2on2 完全着席席替え ドリンク付 '
  },
  3098043: {
    a: 'おひとり様歓迎【2on2形式】【完全着席×スタッフが席替え】【ドリンク付き】【MOST】',
    b: '2on2 完全着席席替え ドリンク付 '
  },
  3098050: {
    a: 'おひとり様歓迎【2on2形式】【完全着席×スタッフが席替え】【ドリンク付き】【MOST】',
    b: '2on2 完全着席席替え ドリンク付 '
  },
  3086610: {
    a: 'おひとり様歓迎【上野公園内】【お酒飲み放題×パン＆スイーツ食べ放題】【無料手荷物】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'お一人様歓迎 お酒×パンスイーツ食べ放題'
  },
  3086632: {
    a: 'おひとり様歓迎【食事付き×お酒飲み放題】【フリータイム無し】【キツネ】【MOST】',
    b: 'おひとり様歓迎 食事×お酒飲み放題'
  },
  3086634: {
    a: 'おひとり様歓迎【食事付き×お酒飲み放題】【フリータイム無し】【キツネ】【MOST】',
    b: 'おひとり様歓迎 食事×お酒飲み放題'
  },
  3089417: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3089415: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3089267: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3089268: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3089265: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3089419: {
    a: 'ケーキセット付【1on1形式】【全席ソファ】【お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: 'ケーキセット×お酒 1on1 全席ソファ'
  },
  3098460: {
    a: 'ディナー付【2on2】【ビュッフェ料理×お酒飲み放題】【1人参加歓迎】【Bee天神店】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3098456: {
    a: 'ディナー付【2on2】【ビュッフェ料理×お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3098457: {
    a: 'ディナー付【2on2】【ビュッフェ料理×お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3098458: {
    a: 'ディナー付【2on2】【ビュッフェ料理×お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3098459: {
    a: 'ディナー付【2on2】【ビュッフェ料理×お酒飲み放題】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3086591: {
    a: 'ディナー付【2on2】【ビュッフェ料理×飲み放題】【無料手荷物】【フリータイム無し】【キツネ】【MOST】',
    b: '2on2 ビュッフェディナー×飲み放題'
  },
  3097724: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097730: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097726: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097732: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097727: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097728: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097733: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097729: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3097734: {
    a: 'ランチ付【1on1トーク】【全席ソファ】【お酒飲み放題】【無料手荷物】【初心者向け】【フリータイム無し】【1人参加歓迎】【MOST】',
    b: '1on1 ランチ付飲み放題 初心者向け'
  },
  3098962: {
    a: '初心者向け【2on2】【着席形式×スタッフが席替え】【高級レストラン】【約100種類のドリンク飲み放題】【フリータイム無し】【MOST】',
    b: '初心者向け 2on2着席席替え 飲み放題'
  },
  3097712: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3097714: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3097715: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3097716: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3097717: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3088294: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  },
  3088290: {
    a: '女性無料体験☆ミスド食べ放題【初心者のみ】【高級スイーツ×お酒】【ルール説明あり】【MOST】',
    b: '女性無料体験 初心者のみ スイーツ×お酒'
  }
}

// Utility functions
export const getEventTitleForABTest = (eventId, isBPattern) => {
  const mapping = EVENT_TITLE_MAPPING[eventId]
  if (!mapping) return null
  return isBPattern ? mapping.b : mapping.a
}

export const isEventInABTest = eventId => {
  return Object.prototype.hasOwnProperty.call(EVENT_TITLE_MAPPING, eventId)
}
